<template>
    <div class="button-bottom" @click="routeButton()" >
        <button class="bottom" 
                :style="bgButton" :disabled="disabled"
                :class="disabled == true ? 'disabled' : ''">
            <p>
                {{ textButton }}
            </p>
        </button>
    </div>
</template>
<script>
export default {
    props: {
        textButton : {
            type: String,
            required: true
        },
        routeString : {
            type: String,
            required: false
        },
        action : {
            type : Boolean,
            default : true
        },
        color : {
            type : String,
            default : 'linear-gradient(to right, #a700ff , #9100d2);'
        },
        disabled : {
            type : Boolean,
            default : false
        }
    },
    methods: {
        routeButton(){
            if(this.action && this.disabled == false){
                let route = this.routeString
                if(!route){
                    return
                }
                this.$router.push(`/${route}`)
            }
        }
    },
    computed:{
        bgButton(){
            return {
                'background-color' : this.color
            }
        }
    }
    
}
</script>
<style lang="scss" scoped>

    .button-bottom{
        width: 100%;
        margin: 0 auto;
        height: 100%;

        .bottom {
            width: 100%;
            height: 100%;
            border: none;
            color: #2f353a;
            font-weight: bold;
            text-transform: uppercase;
            letter-spacing: 3px;
            outline: none;
            cursor: pointer;
            background-color: #fff581;

            p{
                font-size: 13px;
            }
        }

        .disabled{

            background-color: #000000 !important;
            color: #3b4345;
        }
    }

    @media only screen and (min-width: 750px){
        .button-bottom{
            width: 100%;
            height: 80px;
            display: flex;
            justify-content: center;
            align-items: center;

            .bottom{
                height: 70%;
                width: 30%;
            }

        }
    }
</style>
